import React, { useEffect, useState } from "react";
import HowToUseComponent from "../../components/how-to-use/HowToUseComponent";
import { getSkincareStepsApi } from "../../services/skincare.service";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { useLocation } from "react-router-dom";
import PageLoader from "../../components/common/loader/pageLoader";
import { getSkinProfileApi } from "../../services/skinProfile.service";
import { getProfileApi } from "../../services/profile.service";

const HowToUseContainer = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [currentSkincare, setCurrentSkincare] = useState();

  const dispatch = useAppDispatch();

  const params = useLocation().search;
  const token = new URLSearchParams(params).get("token");

  const fetchSkinProfile = () => {
    setLoading(true);
    dispatch(
      getSkinProfileApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (data: any) => {
          setData(data);
        },
        unAunthicatedCallback: () => {
          // localStorage.clear();
          // navigate("/login");
        },
      })
    );
  };

  const fetchCurrentSkincare = () => {
    setLoading(true);
    dispatch(
      getSkincareStepsApi({
        finalCallback: () => {
          setLoading(false);
        },
        successCallback: (currentSkincare: any) => {
          setCurrentSkincare(currentSkincare);
        },
      })
    );
  };

  const fetchProfile = () => {
    dispatch(
      getProfileApi({
        finalCallback: () => {},
        successCallback: () => {},
        unauthenticatedCallback: () => {},
      })
    );
  };

  useEffect(() => {
    if (token != null) {
      localStorage.setItem("alrounderToken", token);
    }
    console.log("tokensss", token);
    // fetchProfile();
    fetchSkinProfile();
    fetchCurrentSkincare();
  }, []);

  if (loading) {
    return <PageLoader />;
  }

  if (data) {
    console.log("curretn", currentSkincare);
    return <HowToUseComponent data={data} currentSkincare={currentSkincare} />;
  }
  // return <HowToUseComponent data={data} currentSkincare={currentSkincare} />;
};

export default HowToUseContainer;
